export default __webpack_public_path__ + "static/media/VisionPlanthroughCigna.c418af91.svg";